import * as Api from "utils/api/api";
import {
    getTaskDetails,
    removeSelectedDocument,
    updateTaskDetailsAfterAction,
} from "components/taskdetails-remake/taskDetails.action";
import { showNotification } from "components/notifications/notification.action";
import {seamlessLoadTasks} from "components/mytasks/myTasks.action";
import {ForwardActionData, DeleteActionData, AddActionData, RequestReviewActionData, ReassignActionData, CancelDocumentActionData, ReviewTaskActionData, ApproveDirectlyActionData, RejectDirectlyActionData, RejectActionData, EmailActionData, SendForApprovalActionData} from "types/modals";
import { Dispatch } from "redux";
import { TASK_ACTIONS } from "utils/constants";
import { mapErrorMessage } from "utils/errorHandle.function";
import {replacePlaceholderInMessage} from "utils/valueFormatter.function";

export function deleteAttachment( data: DeleteActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.deleteAttachment(data.key, data.collectionGuid, data.id).then(function() {
                dispatch(removeSelectedDocument());
                dispatch(getTaskDetails(data.key));
                dispatch(showNotification(data.deleteMessage));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function addAttachment(data: AddActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.addAttachment(data.key, encodeURIComponent(data.title), encodeURIComponent(data.comment), data.file).then(function (response: any) {
                let documentName = JSON.parse(response)?.text || '';
                dispatch(updateTaskDetailsAfterAction(data.key, TASK_ACTIONS.ADD_ATTACHMENT));
                dispatch(showNotification(documentName + " " + data.addMessage));
                successCallback();
            },
            function (error: any) {
                errorCallback({ fileTooBigMessage: mapErrorMessage(error)});
            }
        );
    }
}

export function forwardTask(data: ForwardActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.forwardTask(data.key,data.comment, data.recipient).then(function () {
                dispatch(showNotification(data.forwardMessage));
                successCallback();
            },
            function (error:any) {
                errorCallback({ error: error });
            });
    }
}

export function postponeTasks(taskKeys, comment, dayFields, postponeMessage, successCallback, errorCallback) {
    return function(dispatch: Dispatch<any>) {
        Api.postponeTask(taskKeys, comment, dayFields.thisDay, dayFields.daysFromNow, dayFields.daysBefore).then(function(response) {
                if (response.success > 0) {
                    dispatch(showNotification(postponeMessage));
                    if (response.total !== response.success) {
                        errorCallback();

                    } else {
                        successCallback();
                        dispatch(seamlessLoadTasks());
                    }
                } else {
                    errorCallback();
                }

            },
            function(error) {
                errorCallback({ error: error });
            },
        );
    }
}


export function reassignTasks(data: ReassignActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.OverviewReassign(data.keys, data.comment, data.recipient).then(function(response: any) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}


export function cancelDocument(data: CancelDocumentActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.cancelDocument(data.companyId, data.key, data.comment).then(function(response: { message: string }) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function requestReview(data: RequestReviewActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.requestReviewTask(data.key, data.recipient, data.comment).then(function (response) {
                const withPlaceholder = replacePlaceholderInMessage(response.message, data.taskDescription);
                dispatch(showNotification(withPlaceholder));
                successCallback();
            },
            function (error:any) {
                errorCallback({ error: error });
            });
    }
}

export function reviewTask(data: ReviewTaskActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.reviewTask(data.key, data.comment).then(function (response: any) {
                const withPlaceholder = replacePlaceholderInMessage(response.message, data.taskDescription);
                dispatch(showNotification(withPlaceholder));
                successCallback();
            },
            function (error:any) {
                errorCallback({ error: error });
            });
    }
}

export function rejectTask(data: RejectActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        const apiCall = data.uid
            ? Api.rejectTaskByUID(data.uid, data.comment)
            : Api.rejectTask(data.key, data.comment);

        apiCall.then(function (response: any) {
                const withPlaceholder = replacePlaceholderInMessage(response.message, data.taskDescription);
                dispatch(showNotification(withPlaceholder));
                successCallback();
            },
            function (error:any) {
                errorCallback({ error: error });
            });
    }
}

export function approveDocumentDirectly(data: ApproveDirectlyActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.approveDocumentDirectly(data.comment, data.taskIds, data.companyId).then(function(response: { message: string }) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function fetchDraftComment(showComments: boolean, tasks: Array<Record<string, any>>, onSuccess: (text: string) => void) {
    return function() {
        if (!showComments || tasks.length !== 1 || !tasks[0]?.documentUid) {
            return;
        }
        Api.getDraftComment(tasks[0].documentUid).then(function(response: { text?: string }) {
            if (response?.text) {
                onSuccess(response.text);
            }
        }).catch(function(error: any) {
            console.error("Failed to fetch draft comment", error);
        });
    }
}

export function updateUserSettings(userSettings: Record<string, any>, companyId: string) {
    return function() {
        Api.updateUserSettings(userSettings, companyId).catch(function(error: any) {
            console.error("Failed to update user settings", error);
        });
    }
}

export function rejectDocumentDirectly(data: RejectDirectlyActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.rejectDocumentDirectly(data.comment, data.taskIds, data.companyId).then(function(response: { message: string }) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function emailTask(data: EmailActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        const apiCall = data.sendDocument
            ? Api.emailDocument(data.key, data.to, data.comment, data.subject, data.sendAttachment, data.sendCopy, data.cc, data.bcc, data.companyId)
            : Api.emailTask(data.key, data.to, data.comment, data.subject, data.sendAttachment, data.sendCopy, data.cc, data.bcc);

        apiCall.then(function(response: { message: string }) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function sendDocumentForApproval(data: SendForApprovalActionData, successCallback: Function, errorCallback: Function) {
    return function(dispatch: Dispatch<any>) {
        Api.sendDocumentForApproval(data.comment, data.taskIds, data.companyId).then(function(response: { message: string }) {
                dispatch(showNotification(response.message));
                successCallback();
            },
            function(error: any) {
                errorCallback({ error: error });
            }
        );
    }
}

export function simulateWorkflowGraph(taskKey: string, companyId: string, successCallback: Function, errorCallback: Function) {
    return function() {
        Api._simulateWorkflowGraph(taskKey, companyId).then(
            function(response: any) {
                successCallback(response);
            },
            function(error: any) {
                errorCallback(error);
            },
        );
    }
}